import { TabStyles } from '@tableau/widgets';
import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass } from '../../style';

const cssPrefix = 'BackgroundJobs';
export namespace BackgroundJobStyles {
  export const MastheadArea = cssClass(cssPrefix, 'masthead-area', {
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingRight: TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
  });

  export const SummaryInfoContainer = cssClass(cssPrefix, 'summary-info-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    $nest: {
      '&>div': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
      }
    }
  });

  export const SummaryInfoButtonGroup = cssClass(cssPrefix, 'summary-info-button-group', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '4px',
    $nest: {
      '&>*': {
        paddingRight: TabStyles.Spacing.MediumSpace,
        paddingLeft: TabStyles.Spacing.MediumSpace,
      },
      '&>*:last-child': {
        paddingRight: 0,
      },
      '&>*:first-child': {
        paddingLeft: 0,
      }
    }
  });

  export const SummaryInfoItem: React.CSSProperties = {
    minWidth: 0, // 0 is the default
    color: CommonStyles.Colors.Grey102,
    fontSize: '14px',
  };
}
